import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CallToAction from "@/components/CallToAction";
import WhatsAppChat from "@/components/WhatsAppChat";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>About benchr.ai - E-commerce Competitive Intelligence & AI Market Analysis</title>
        <meta name="description" content="Discover how Benchr helps e-commerce businesses gain competitive insights with AI-powered analytics to make data-driven decisions and outperform competitors." />
        <meta name="keywords" content="e-commerce intelligence, competitive analysis, AI market analysis, pricing strategy, retail analytics, e-commerce optimization, market data" />
        <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About Benchr - E-commerce Competitive Intelligence Platform",
            "description": "Benchr is an AI-powered e-commerce competitive intelligence platform that helps businesses stay ahead of their competition through comprehensive data-driven insights and real-time market analysis.",
            "keywords": ["e-commerce intelligence", "competitive analysis", "AI market analysis", "pricing strategy", "retail analytics"],
            "publisher": {
              "@type": "Organization",
              "name": "Benchr",
              "logo": {
                "@type": "ImageObject",
                "url": "/lovable-uploads/5b3fc61d-09cc-4356-aca7-ef3a45266769.png"
              },
              "founder": {
                "@type": "Person",
                "name": "Benchr Founder"
              },
              "foundingDate": "2022"
            }
          }
        `}
        </script>
      </Helmet>
      <Navbar />
      <main className="flex-grow pt-20">
        <section className="py-20 md:py-28">
          <div className="container max-w-7xl mx-auto px-6 md:px-10">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-benchr-900 dark:text-white mb-8">
                About Benchr
              </h1>
              <div className="prose dark:prose-invert prose-lg max-w-none prose-headings:text-benchr-900 dark:prose-headings:text-white prose-p:text-benchr-700 dark:prose-p:text-benchr-300">
                <p className="lead text-xl text-benchr-600 dark:text-benchr-300 mb-10">
                  Benchr is an e-commerce competitive intelligence platform that helps businesses stay ahead of their competition through data-driven insights.
                </p>
                
                <h2>Our Mission</h2>
                <p>
                  Our mission is to provide businesses with comprehensive e-commerce data and insights, helping them make informed decisions about their product offerings, pricing strategies, and market positioning. We believe that data-driven decision making leads to better business outcomes and a more competitive marketplace.
                </p>
                
                <h2>What We Do</h2>
                <p>
                  Benchr provides real-time insights on e-commerce products, pricing, and market trends. Our platform collects, analyzes, and delivers insights on millions of products across thousands of e-commerce sites worldwide, helping businesses understand their competitive landscape and identify growth opportunities.
                </p>
                
                <h2>Our Technology</h2>
                <p>
                  We've built a powerful data collection and analysis infrastructure capable of extracting structured data from any e-commerce site globally. Our technology combines advanced web scraping capabilities with AI-powered data processing to ensure our clients receive accurate, timely, and actionable insights.
                </p>
                
                <h2>Our Team</h2>
                <p>
                  Benchr was founded by a team of e-commerce experts and data scientists who recognized the need for better competitive intelligence tools in the ever-evolving online commerce space. Our team brings together expertise in data engineering, e-commerce operations, and business intelligence to deliver a platform that truly meets the needs of modern e-commerce businesses.
                </p>
                
                <h2>Join Us</h2>
                <p>
                  We're always looking for talented individuals passionate about e-commerce, data, and technology. If you're interested in joining our team, check out our careers page for current opportunities.
                </p>
              </div>
            </div>
          </div>
        </section>
        <CallToAction />
      </main>
      <Footer />
      <WhatsAppChat phoneNumber="+33600000000" message="Hello, I'd like to learn more about Benchr services." />
    </div>
  );
};

export default About;
